function hideFooterWidget(): void {
  const section = document.querySelector<HTMLElement>(
    ".shopify-section-group-footer-group .apps-section"
  );
  if (section) section.style.display = "none";
}

function waitForWidget(callback: () => void): void {
  let button = document.querySelector(".jm-store-summary-button");
  if (button) {
    callback();
    return;
  }

  let tries = 0;
  const interval = setInterval(() => {
    button = document.querySelector(".jm-store-summary-button");
    if (button || ++tries > 40) {
      clearInterval(interval);
      if (button) callback();
    }
  }, 250);
}

export function initReviewsTab(): void {
  const tab = document.getElementById("custom-reviews-tab");
  if (!tab) return;

  waitForWidget(hideFooterWidget);

  const openReviews = (): void => {
    const viewBtn = document.querySelector<HTMLElement>(".jm-store-summary-button");
    if (viewBtn) {
      viewBtn.click();
      return;
    }

    const badge = document.querySelector<HTMLElement>(
      ".jdgm-prev-badge__text a, .jdgm-all-reviews-text a"
    );
    badge?.click();
  };

  tab.addEventListener("click", openReviews);
  tab.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    openReviews();
  });
}
